/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import PropTypes from 'prop-types';
import React     from 'react';
import styles    from './PushSentRate.scss';

let PushSentRate = ({
    numFailed,
    numSent,
  }) => {
  // let rateNum = numFailed / numSent * 100;
  // let rateNum = 100 - (numFailed / numSent) * 100;
  let rateNum = numSent / (numSent + numFailed) * 100;

  if (isNaN(rateNum) || rateNum < 0) {
    rateNum = 0;
  }

  let rateStr;
  if (rateNum % 1 === 0) {
    // Integer rate
    rateStr = rateNum.toFixed(0);
  } else if (rateNum < 10) {
    // e.g. 0.01%, 1.23%
    rateStr = rateNum.toFixed(2);
  } else {
    // e.g. 34.9%, 100%
    rateStr = rateNum.toPrecision(3);
  }

  return (
    <div className={styles.wrapper}>
      <div className={[styles.count_wrap, styles.sent].join(' ')} style={{ textAlign: 'right' }}>
        <div className={styles.count}>{numSent}</div>
        <div className={styles.count_label}>Delivered</div>
      </div>
      <div className={styles.chart} data-percentage={Math.round(rateStr)} data-text={rateStr}>
        <div className={[styles.completed, styles.active].join(' ')}></div>
        <div className={styles.rate_label}>Success Rate</div>
      </div>
      <div className={[styles.count_wrap, styles.failed].join(' ')} style={{ textAlign: 'left' }}>
        <div className={styles.count}>{numFailed}</div>
        <div className={styles.count_label}>Failed</div>
      </div>
    </div>
  );
};


PushSentRate.propTypes = {
  numFailed: PropTypes.number.isRequired,
  numSent: PropTypes.number.isRequired,
};

export default PushSentRate;
